import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../../helpers/Constants";
import { makeStyles } from "@material-ui/core/styles";
import CheckedTable from "components/Table/CheckedTable";
import Spinner from "components/Spinner";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { yieldTableHeaders, createYieldRecord } from "../../helpers/schemas/Yield";
import YieldCreator from "./YieldCreator";
import YieldEditor from "./YieldEditor";
const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
}));

export default function YieldCrud() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("");
  const [userError, setUserError] = useState(undefined);
  const [tableLoading, setTableLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [farmsKv, setYieldsKv] = useState([]);
  const [usersKv, setUsersKv] = useState([]);
  const [cropsKv, setCropsKv] = useState([]);
  const [seasonsKv, setSeasonsKv] = useState([]);
  useEffect(() => {
    setTableLoading(true);
    axios
      .get(`${baseUrl}yields`)
      .then((response) => {
        console.log(response);
        let result = response.data.map((rec) => createYieldRecord(rec));
        
        setData(result);
        setTableLoading(false);
      })
      .catch((error) => {
        console.log(error);
        console.log("xxxx err", JSON.stringify(error));
        setTableLoading(false);
      });
    axios
      .get(`${baseUrl}farms`)
      .then((response) => {
        let result = response.data.map((rec) => {
          return { key: rec.id, value: rec.name };
        });
        setYieldsKv(result);
      })
      .catch((error) => {
        console.log("xxxx err", JSON.stringify(error.response));
      });
    axios
      .get(`${baseUrl}crops`)
      .then((response) => {
        let result = response.data.map((rec) => {
          return { key: rec.id, value: rec.name };
        });
        setCropsKv(result);
      })
      .catch((error) => {
        console.log("xxxx err", JSON.stringify(error.response));
      });
    axios
      .get(`${baseUrl}seasons`)
      .then((response) => {
        let result = response.data.map((rec) => {
          return { key: rec.id, value: rec.name };
        });
        setSeasonsKv(result);
      })
      .catch((error) => {
        console.log("xxxx err", JSON.stringify(error.response));
      });
    axios
      .get(`${baseUrl}users`)
      .then((response) => {
        let result = response.data.map((rec) => {
          return { key: rec.id, value: rec.firstName + " " + rec.lastName };
        });
        setUsersKv(result);
      })
      .catch((error) => {
        console.log("xxxx err", JSON.stringify(error.response));
      });
  }, []);

  function loadEditData(tableData) {
    let selected = {};
    Object.keys(tableData).forEach((k) => (selected[k] = tableData[k].value));
    return selected;
  }
  function saveEdit(edited) {
    setUserError(undefined);
    setStatus("");
    setLoading(true);
    axios
      .put(baseUrl + "yields/" + edited.id, edited)
      .then((newRecord) => {
        let transformed = createYieldRecord(newRecord.data);
        let newData = data.map((oldRecord) => {
          let updated =
            oldRecord.id.value === edited.id ? transformed : oldRecord;
          return updated;
        });
        setFormData(transformed);
        setData(newData);
        setLoading(false);
        setStatus("SUCCESS");
      })
      .catch((error) => {
        console.log("xxx error", JSON.stringify(error));
        if (error.response.status === 400) {
          setUserError(error.response.data.message);
        }
        setLoading(false);
        setStatus("FAILED");
      });
  }
  function create(record) {
    console.log("reaches here");
    setUserError(undefined);
    setStatus("");
    setLoading(true);
    axios
      .post(baseUrl + "yields", record)
      .then(() => {
        setLoading(false);
        setStatus("SUCCESS");
      })
      .catch((error) => {
        console.log("xxx error", JSON.stringify(error));
        setLoading(false);
        setStatus("FAILED");
      });
  }
  function handleBackToCreate() {
    setFormData({});
  }
  const classes = useStyles();
  return (

    <div>
      <div className={classes.root}>
        {formData.id ? (
          <div>
            <Tooltip title="Back to create">
              <IconButton onClick={handleBackToCreate}>
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <YieldEditor
              onEdit={saveEdit}
              loading={loading}
              formData={loadEditData(formData)}
              status={status}
              farmsKv={farmsKv}
              cropsKv={cropsKv}
              seasonsKv={seasonsKv}
              usersKv={usersKv}
            />
          </div>
        ) : (
          <YieldCreator
            onCreate={create}
            loading={loading}
            status={status}
            userError={userError}
            farmsKv={farmsKv}
            cropsKv={cropsKv}
            seasonsKv={seasonsKv}
            usersKv={usersKv}
          />
        )}
      </div>
      {tableLoading && <Spinner />}
      <CheckedTable
        title="Yield Forecast"
        headers={yieldTableHeaders}
        data={data}
        setSelected={setFormData}
        selected={formData}
      />
    </div>
  );
}
